import React, { Component } from 'react';
import { connect } from 'react-redux';
import ExpirationRow from '../containers/ExpirationRow';
import VehicleSelectRow from '../containers/registration/VehicleSelectRow';
import RegistrationConsole from '../containers/registration/RegistrationConsole';
import TotalBaseAndSVCFee from '../containers/registration/TotalBaseAndSVCFee';
import TotalPlateFee from '../containers/registration/TotalPlateFee';
import PenaltyFee from '../containers/registration/PenaltyFee';
import TotalTransferFee from '../containers/registration/TotalTransferFee';
import CommercialVesselFee from '../containers/registration/CommercialVesselFee';
import TotalMobileHomeFee from '../containers/registration/TotalMobileHomeFee';
import SubTotalFeesCredit from '../containers/registration/SubTotalFeesCredit';
import CreditTotal from '../containers/registration/CreditTotal';
import RegistrationTotal from '../containers/registration/RegistrationTotal';
import VehicleWeightFee from '../containers/registration/VehicleWeightFee';
import InitialRegistrationFee from '../containers/registration/InitialRegistrationFee';
import PersonalizedPlateFee from '../containers/registration/PersonalizedPlateFee';
import SpecialtyPlate from '../containers/registration/SpecialtyPlate';
import ParkPlacards from '../containers/registration/ParkPlacards';
import MailFee from '../containers/registration/MailFee';
import SecondYearFee from '../containers/registration/SecondYearFee';

class RegistrationFees extends Component {
  render() {
    const { monthsFromNow } = this.props;
    return (
      <div className="Box">

        <ExpirationRow />

        <div className="Registration">
          <div className="Registration-mask" style={{ display: monthsFromNow ? 'none' : 'block' }}></div>
          <RegistrationConsole />
          <VehicleSelectRow />
          <TotalBaseAndSVCFee />
          <CommercialVesselFee />
          <TotalMobileHomeFee />
          <VehicleWeightFee />
          <SecondYearFee />
          <CreditTotal />
          <SubTotalFeesCredit />
          <PenaltyFee />
          <InitialRegistrationFee />
          <TotalPlateFee />
          <TotalTransferFee />
          <PersonalizedPlateFee />
          <SpecialtyPlate />
          <ParkPlacards />
          <MailFee />
          <RegistrationTotal />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    monthsFromNow: state.registration.monthsFromNow,
  };
};

export default connect(mapStateToProps)(RegistrationFees);



// WEBPACK FOOTER //
// ./src/sections/RegistrationFees.js